import styled from 'styled-components'

interface DesktopDeviceStyledProps {
    color: string
    colorDark: string
    colorLight: string
    screenBorderColor: string
}

export const DesktopDevice = styled.div`
    .device,
    .device * {
        &,
        &::before,
        &::after {
            box-sizing: border-box;
            display: block;
        }
    }

    .device-frame {
        background: ${({ colorLight }: DesktopDeviceStyledProps) => colorLight};
        border-radius: 18px;
        box-shadow: ${({ colorDark }: DesktopDeviceStyledProps) => `inset 0 0 0 1px ${colorDark}`};
        height: 440px;
        padding: 16px 16px 80px 16px;
        position: relative;
        width: 640px;

        &::after {
            background: ${({ color }: DesktopDeviceStyledProps) => color};
            border-radius: 0 0 18px 18px;
            bottom: 1px;
            box-shadow: ${({ colorDark }: DesktopDeviceStyledProps) => `inset 0 0 18px 0 ${colorDark}`};
            content: '';
            height: 63px;
            left: 1px;
            position: absolute;
            width: 638px;
            opacity: 0.8;
        }

        &::before {
            background: ${({ screenBorderColor }: DesktopDeviceStyledProps) => `rgba(${screenBorderColor}, 1)`};
            border-radius: 50%;
            content: '';
            height: 6px;
            left: 50%;
            margin-left: -3px;
            position: absolute;
            text-align: center;
            top: 6px;
            width: 6px;
            z-index: 9;
        }
    }

    .device-screen {
        border: ${({ screenBorderColor }: DesktopDeviceStyledProps) => `2px solid ${screenBorderColor}`};
        border-radius: 2px;
        height: 342px;
        width: 608px;
    }

    .device-stand {
        &::before {
            background: ${({ colorDark, color, colorLight }: DesktopDeviceStyledProps) =>
                `linear-gradient(to bottom, rgba(0,0,0,0.2),transparent 40%),
                linear-gradient(to bottom, ${colorDark} 0,  ${color} 60%, ${colorLight} 80%,  ${color} 90%, ${colorDark} 100%)`};

            content: '';
            height: 92px;
            margin: 0 auto;
            position: relative;
            width: 152px;
        }

        &::after {
            background: ${({ colorDark, color }: DesktopDeviceStyledProps) =>
                `radial-gradient(circle at center, ${color} 0, ${colorDark} 100%)`};
            border-top: ${({ colorLight }: DesktopDeviceStyledProps) => `1px solid ${colorLight}`};
            content: '';
            height: 6px;
            margin: 0 auto;
            position: relative;
            width: 152px;
        }
    }

    .device-stand-base {
        background: transparent;
        border-radius: 0 0 3px 3px;
        bottom: 0;
        box-shadow: -61px 0 red, 61px 0 red;
        box-shadow: ${({ colorDark }: DesktopDeviceStyledProps) => `-61px 0 ${colorDark}, 61px 0 ${colorDark}`};
        height: 2px;
        left: 50%;
        margin: auto;
        width: 30px;
    }
`
